import { FC } from 'react'

import { Box, Typography } from '@mui/material'

import { useUATaxonomy } from '../../hooks/useUATaxonomy'
import { LABEL_WIDTH, ROW_BOTTOM_PAD, ROW_H, ROW_TOP_PAD, TIME_AXIS_H } from './TimelinePalette'

interface TimelineLegendProps {
  motivationKeysInOrder: string[]
}

/**
 * Sticky left-hand label column for {@link MotivationTimeline}. Rendered
 * outside the chart's horizontal scroll container so the motivation names
 * stay put while the timeline scrolls. The trailing spacer matches the
 * chart's x-axis strip so the columns end flush at the bottom.
 */
export const TimelineLegend: FC<TimelineLegendProps> = ({ motivationKeysInOrder }) => {
  const { motivationLabel } = useUATaxonomy()

  return (
    <Box
      sx={{
        width: LABEL_WIDTH,
        minWidth: LABEL_WIDTH,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        pt: `${ROW_TOP_PAD}px`,
        pr: 1.5,
        backgroundColor: 'background.paper',
      }}
    >
      {motivationKeysInOrder.map((key) => (
        <Box key={key} sx={{ height: ROW_H, display: 'flex', alignItems: 'center' }}>
          <Typography variant="caption" sx={{ fontSize: 12, lineHeight: 1.3, color: 'text.secondary', whiteSpace: 'nowrap' }}>
            {motivationLabel(key)}
          </Typography>
        </Box>
      ))}
      <Box sx={{ height: TIME_AXIS_H + ROW_BOTTOM_PAD }} />
    </Box>
  )
}
